import React from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

import Dashboard from './Dashboard';
import DailyAttendance from './DailyAttendance';
import MonthlyAttendance from './MonthlyAttendance';
import TeacherAttendanceReport from './TeacherAttendanceReport';
import TeacherProfile from './TeacherProfile';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import HelpPage from './HelpPage';
import DeveloperGuidePage from './DeveloperGuidePage';
import ReportMonthlyAttendance from './ReportMonthlyAttendance';
import ReportDailyAttendance from './ReportDailyAttendance';
import EmpIdMapping from './EmpIdMapping';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './App.css';
import './Sidebar.css';
import './AdminLogin.css';
import './AdminDashboard.css';

// Global axios interceptor: redirect to login on 401 (expired token)
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401 && window.location.pathname.startsWith('/admin/')) {
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUser');
            window.location.href = '/admin';
        }
        return Promise.reject(error);
    }
);

function ComingSoon({ title }) {
    return (
        <div className="card p-fluid" style={{ textAlign: 'center', padding: '2rem' }}>
            <h1>{title}</h1>
            <p>This feature is coming soon...</p>
        </div>
    );
}

// Protected Route wrapper for admin pages
function ProtectedAdminRoute({ children }) {
    const token = localStorage.getItem('adminToken');
    const location = useLocation();
    
    if (!token) {
        return <Navigate to="/admin" state={{ from: location }} replace />;
    }
    return children;
}

// Redirect to dashboard if already logged in
function AdminLoginRoute() {
    const token = localStorage.getItem('adminToken');
    
    if (token) {
        return <Navigate to="/admin/dashboard" replace />;
    }
    return <AdminLogin />;
}

function App() {
    return (
        <Router >
            <Routes>
                {/* Admin Routes - Full page without sidebar */}
                <Route path="/admin" element={<AdminLoginRoute />} />
                <Route path="/admin/dashboard" element={
                    <ProtectedAdminRoute>
                        <AdminDashboard />
                    </ProtectedAdminRoute>
                } />
                <Route path="/admin/emp-id-mapping" element={
                    <ProtectedAdminRoute>
                        <EmpIdMapping />
                    </ProtectedAdminRoute>
                } />
                
                {/* Developer Guide - Full page without sidebar */}
                <Route path="/developer-guide" element={<DeveloperGuidePage />} />
                
                {/* Main App Routes - With sidebar */}
                <Route path="/*" element={
                    <div className="app-container">
                        <Sidebar />
                        <div className="main-content">
                            <Routes>
                                <Route path="/" element={<Dashboard />} />
                                <Route path="/daily" element={<DailyAttendance />} />
                                <Route path="/monthly" element={<MonthlyAttendance />} />
                                <Route path="/teacher-report/:teacherId" element={<TeacherAttendanceReport />} />
                                <Route path="/profile" element={<TeacherProfile />} />
                                <Route path="/reports/monthly" element={<ReportMonthlyAttendance />} />
                                <Route path="/reports/daily" element={<ReportDailyAttendance />} />
                                <Route path="/help" element={<HelpPage />} />
                                <Route path="*" element={<Navigate to="/" replace />} />
                            </Routes>
                        </div>
                    </div>
                } />
            </Routes>
        </Router>
    );
}

export default App;
